import { Dict } from "../defines";
import DynamicConfigFglas from "./configs";

class DynamicConfig {
  config: Dict<DynamicConfigFglas>;

  constructor(config: Dict) {
    this.config = config || {
      baseSponsorUrl: "/",
    };
  }

  set(k: string, v: any) {
    this.config[k] = v;
  }

  get(k: DynamicConfigFglas): any {
    return this.config[k];
  }

  getState() {
    return this.config;
  }
}

export default DynamicConfig;
